import { useEffect, useMemo } from "react";
import { useLocation } from "react-router";
import { useFooterConfig } from "@/core/hooks/useFooterConfig";
import { useUiStore } from "@core/stores/uiStore";
import { cn } from "@/core/utils/domUtil";
import IconCs from "@/assets/svg/footer/icon-cs.svg?react";

export default function Footer() {
  const isPcView = useUiStore((state) => state.isPcView());
  const footerConfig = useFooterConfig();
  const location = useLocation();
  const isMain = useMemo(() => location.pathname === "/", [location.pathname]);

  useEffect(() => {
    if (window?.ncui?.footer && !document.querySelector(".footer") && footerConfig) {
      new window.ncui.footer(footerConfig);
    }
  }, [footerConfig]);

  return (
    <footer id="footer" className={cn("wrap-footer relative", isMain && "mt-0!")}>
      {isPcView && footerConfig?.helpdesk?.isActive && (
        <div className={cn("footer-xl:flex absolute top-[130px] left-1/2 hidden h-[74px] w-[140px] translate-x-[449px] items-center justify-center gap-[10px] rounded-md border border-gray-300 bg-[rgba(70,70,70,0.05)]")}>
          <IconCs />
          <p className="text-md">
            고객센터<span className="block font-bold">{footerConfig?.helpdesk?.phone}</span>
          </p>
        </div>
      )}
    </footer>
  );
}
